import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDataFieldViewBase } from '@fi-app/data-field/data-field-view/data-field-view-base';

@Component({
    selector: 'data-field-view-org-nr',
    template: `
        <fi-profile-view-data
            [label]="'business_unit.org_nr' | fiAppText"
            [content]="dataFieldObject.OrganisationNumber"
        >
        </fi-profile-view-data>
    `,
    styleUrls: ['./org-nr.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-view-org-nr' },
    standalone: false,
})
export class FiDataFieldViewOrgNrComponent extends FiDataFieldViewBase {
    get isNotEmpty() {
        return !!this.dataFieldObject.OrganisationNumber;
    }
}
